import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const path = "/workspace";

export const switchWorkspace = createCrudVuexModule({
  moduleName: "switchWorkspace",
  path: path,

  namespaced: true,
  persistent: ["selected"],
  state: () => ({
    selected: undefined,
  }),
  getters: {
    selected: (state) => state.selected,
  },

  mutations: {
    selected: (state, value) => {
      if (!value) {
        state.selected = null;
      } else {
        state.selected = { ...value };
      }
    },
    reset: (state, value) => {
      state.selected = null;
    },
  },
  actions: {
    async paginate({ state, commit }, payload) {
      commit("isLoading", true);
      try {
        const response = await rest.post(`${path}/paginate`, payload);

        if (response.data.docs.length > 0 && !response.data.docs.find((w) => w._id == state.selected._id)) {
          commit("selected", response.data.docs[0]);
        }

        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
